import React from 'react'
import Link from 'react-router-dom'

export default class About extends React.Component {
    render() {
        return (
            <h1>About Component!</h1>
        );
    }
}


// WEBPACK FOOTER //
// ./src/About.jsx